import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_2 = { class: "s20 items-center gap-6 px-0 pb-6 collapse-content active" }
const _hoisted_3 = { class: "table separator skin1 sm selection" }
const _hoisted_4 = { class: "font-semibold text-xl" }
const _hoisted_5 = { class: "font-semibold text-xl" }
const _hoisted_6 = { class: "flex-right" }

import { reactive, ref, onMounted } from 'vue';
    import CustomButton from '@/components/CustomButton.vue';
    import { useConfirmationStore } from '@/stores/confirmation.store';
    import axios from 'axios';
    import { useToastStore } from '@/stores/toast.store';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesCartesTableComponent',
  props: {
        collectivite: { type: Object, required: true }
    },
  emits: ['updated'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const emits = __emit;
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const itemsList = ref([] as any[]);
    const paginatedDatas = ref([] as Array<any>);
    const confirmationStore = useConfirmationStore();
    const toastStore = useToastStore();
    const loading = ref(false);

    onMounted(() => {
        doListCarteItems();
    });

    async function doListCarteItems() {
        try {
            loading.value = true;
            const httpResponse = await axios.get(`/backoffice/collectivites/${props.collectivite.id}/get_collectivite_cartes_datas`);
            itemsList.value = httpResponse.data.data;
            pagination.total = itemsList.value.length;
            onPaginate(queryParams.pageNumber);
        } catch (error: any) {
            toastStore.error(error.message ?? "Une erreur est survenue lors de la requête au serveur");
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        const start = (page - 1) * pagination.per_page;
        paginatedDatas.value =  itemsList.value.slice(start, start + pagination.per_page);
        pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
    }

    async function doAssignCardToUser(user_infos: any) {
        const confirmation = await confirmationStore.open(
            "Assignation Carte",
            `Voulez-vous vraiment assigner une carte à l'utilisateur '${user_infos.nom_user + ' ' + user_infos.prenom_user}' ?`
        );
        if (confirmation) {
            try {
                loading.value = true;
                const httpResponse = await axios.post(`/backoffice/users/${user_infos.user_id}/cartes/assigner_carte`, {});
                toastStore.success("Carte assigné avec succès.");
                emits('updated', httpResponse.data);
            } catch (error: any) {
                toastStore.error(error.message ?? "Une erreur est survenue lors de la requête au serveur");
            } finally {
                loading.value = false;
            }
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
      _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
        _createElementVNode("img", {
          src: "/icons/icon-panel-open.svg",
          class: "size-xs icon-neutral mr-2 collapse-icon-open",
          alt: ""
        }),
        _createElementVNode("img", {
          src: "/icons/icon-panel-close.svg",
          class: "size-xs icon-neutral mr-2 collapse-icon-close",
          alt: ""
        }),
        _createTextVNode(" Gérer les cartes ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"container-full-2 s20 mt-1 mb-5\"><div class=\"s7\"><h4 class=\"font-semibold mt-4\">Cartes <span class=\"text-sm text-grey-500\">(recent)</span></h4></div><div class=\"s13 flex justify-content-right\"><button class=\"btn normal ml-4 justify-content-center btn-filtre\"><img src=\"/icons/icon-add.svg\" class=\"btn-icon\" alt=\"\"><span>Créer</span></button><div class=\"form-field-floating default sm s4_mobile ml-3\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tous les lots</option><option value=\"\">Lot1</option></select></div><div class=\"form-field-floating default sm s4_mobile ml-3\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\">Trier</option><option value=\"\" selected>Ordre Décroissant</option><option value=\"\">Ordre Croissant</option><option value=\"\">De A - Z</option><option value=\"\">De Z - A</option></select></div><button class=\"btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter\"><img src=\"/icons/icon-filter.svg\" class=\"btn-icon\" alt=\"\"><span>Options</span></button></div><div class=\"clear-both\"></div><div class=\"filter-set-area\"><div class=\"grid-filter6 mt-4 mb-0\"><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date1\" id=\"date1\" placeholder=\"\"><label for=\"date1\">Date de création &lt;=</label></div><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date2\" id=\"date2\" placeholder=\"\"><label for=\"date2\">Date de création &gt;=</label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter Excel</span></button><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter PDF</span></button></div></div></div>", 1)),
        _createElementVNode("table", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", {
                  class: "btn-circle",
                  for: "check-list1"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    name: "check-list",
                    id: "check-list1"
                  })
                ])
              ]),
              _createElementVNode("th"),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Nom & Prénoms")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Numéro")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-down.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" N° de Lot")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Banque")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Date de création")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Etat")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Statut")
              ]),
              _createElementVNode("th", { class: "flex-right" }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDatas.value, (carte, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "text-grey-700 over-effect over-effect-scale",
                key: index
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("td", { class: "selection-item" }, [
                  _createElementVNode("label", {
                    class: "btn-circle",
                    for: "check-list1"
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      name: "check-list",
                      id: "check-list1"
                    })
                  ])
                ], -1)),
                _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                  _createElementVNode("div", {
                    class: "square-xl rounded-15",
                    style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
                  }, [
                    _createElementVNode("img", {
                      src: '/assets/users_avatar/600w/user.jpg',
                      width: "100%"
                    })
                  ])
                ], -1)),
                _createElementVNode("td", _hoisted_4, _toDisplayString(carte.nom_user + ' ' + carte.prenom_user), 1),
                _createElementVNode("td", _hoisted_5, _toDisplayString(carte.numero_masque_carte ?? '-'), 1),
                _createElementVNode("td", null, _toDisplayString(carte.num_lot_carte ?? '-'), 1),
                _createElementVNode("td", null, _toDisplayString(carte.nom_banque_carte ?? '-'), 1),
                _createElementVNode("td", null, _toDisplayString(carte.created_at_carte ?? '-'), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["tag-state stroke", {'success': carte.etat_assignation, 'warning': !carte.etat_assignation}])
                  }, _toDisplayString(carte.etat_assignation ? 'Assigné' : 'Aucune carte assigné'), 3)
                ]),
                _createElementVNode("td", null, [
                  (carte.etat_assignation)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["tag-state stroke", {'success': ['delivered', 'active'].lastIndexOf(carte.statut_carte) > -1, 'warning': ['delivered', 'active'].lastIndexOf(carte.statut_carte) == -1 }])
                      }, _toDisplayString(carte.statut_label), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_6, [
                    (!carte.carte_id)
                      ? (_openBlock(), _createBlock(CustomButton, {
                          key: 0,
                          type: "button",
                          classesList: 'btn-ultra color2',
                          onClick: ($event: any) => (doAssignCardToUser(carte))
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("span", null, "Assigner carte", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(CustomButton, {
                            type: "button",
                            classesList: 'btn-ultra'
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("img", {
                                src: "/icons/icon-valider.svg",
                                class: "btn-icon icon-neutral",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "En livraison", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(CustomButton, {
                            type: "button",
                            classesList: 'btn-ultra color2 tips'
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("img", {
                                src: "/icons/icon-actif.svg",
                                class: "btn-icon",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Actif", -1)
                            ]))]),
                            _: 1
                          })
                        ], 64))
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_custom_pagination, {
        modelValue: queryParams.pageNumber,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((queryParams.pageNumber) = $event)),
          onPaginate
        ],
        total: pagination.total,
        "per-page": pagination.per_page,
        last_page: pagination.last_page
      }, null, 8, ["modelValue", "total", "per-page", "last_page"])
    ])
  ]))
}
}

})